export enum QuestionChoiceTypeEnum {
  TEXT = 'text',
  DROPDOWN = 'dropdown',
  LIST = 'list',
  CHECKBOX = 'checkbox',
}
